export const RECORD_COLOR = '#F44336'
export const STOP_COLOR = '#2196F3'
export const PLAY_COLOR = '#4CAF50'

// export const RECORD_COLOR = '#cc4c33'
// export const STOP_COLOR = '#3e78b3'
// export const PLAY_COLOR = '#56ad89'
